import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveLessonCreationStudios } from "./retrieve-lesson-creation-studios";
import type { LessonCreationStudiosVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

const initialState: RetrievalState<LessonCreationStudiosVM> = {
  fetching: "idle",
  data: {
    operaOffStudios: [],
    teacherStudios: [],
  },
};

export const retrieveLessonCreationStudiosReducer = createReducer<RetrievalState<LessonCreationStudiosVM>>(initialState, builder => {
  builder.addCase(retrieveLessonCreationStudios.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveLessonCreationStudios.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveLessonCreationStudios.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
